<mat-form-field class="fill" [appearance]="appearance()">
	<mat-label [innerHtml]="label() | escapeHtml"></mat-label>
	<input
		#input
		matInput
		[value]="text()"
		(input)="text.set($event.target.value)"
		[disabled]="formControl().disabled"
		[matAutocomplete]="auto"
	/>
	@if (allowClearing() && !formControl().disabled && selectedOption()) {
		<button
			matSuffix
			mat-icon-button
			mat-small-icon-button
			aria-label="Clear"
			(click)="selectedOption.set(null); text.set('')"
		>
			<mat-icon>close</mat-icon>
		</button>
	}

	<mat-autocomplete
		#auto="matAutocomplete"
		[displayWith]="(option) => option?.name"
		(optionSelected)="selectedOption.set($event.option.value)"
		[requireSelection]="true"
		[autoActiveFirstOption]="true"
	>
		@for ($option of options(); track trackBy()($index, $option.value)) {
			<mat-option [value]="$option">
				@if (itemTemplate()) {
					<ng-container
						*ngTemplateOutlet="
							itemTemplate();
							context: {
								$implicit: $option.value,
								$index: $index,
							}
						"
					></ng-container>
				} @else {
					{{ $option.name }}
				}
			</mat-option>
		}
	</mat-autocomplete>
</mat-form-field>
